import React, { useState, useRef, useEffect } from 'react';
import { Button, Card, message, Input } from 'antd';
import { ArrowLeftOutlined, MailOutlined } from '@ant-design/icons';
import {useNavigate, useLocation, useParams} from "react-router-dom";
import {resendResetCode, validateResetCode} from "../../services/auth";

const VerifyCode = () => {
  const [loading, setLoading] = useState(false);
  const [reSendLoading, setResendLoading] = useState(false);
  const [code, setCode] = useState(['', '', '', '', '', '']);
  const navigate = useNavigate();
  const location = useLocation();
  const inputRefs = useRef([]);
  const { encodedUserId } = useParams();
  const email = location.state?.email || '';
  const userId = encodedUserId ? atob(encodedUserId) : '';
  const focusInput = (index) => {
    const input = inputRefs.current[index];
    if (input) {
      if (input.focus) {
        input.focus();
      } else if (input.input && input.input.focus) {
        input.input.focus();
      }
    }
  };

  useEffect(() => {
    // Focus on first input when component mounts with a small delay
    setTimeout(() => {
      focusInput(0);
    }, 100);
  }, []);

  const handleCodeChange = (index, value) => {
    if (value.length > 1) return;

    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);
    // Auto-focus next input
    if (value && index < 5) {
      focusInput(index + 1);
    }
  };

  const handleKeyDown = (index, e) => {
    // Handle backspace
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      focusInput(index - 1);
    }
  };

  const handleSubmit = async () => {
    const verificationCode = code.join('');

    if (verificationCode.length !== 6) {
      message.error('Please enter all 6 digits');
      return;
    }

    setLoading(true);
    try {
      await validateResetCode({code: verificationCode,userId});
      navigate(`/reset-password/${encodedUserId}`,{
        state: {
          verificationCode: verificationCode,
          userId: userId
        }
      });

    } catch (error) {
      console.log("error", error)
      message.error(error.response.data.error.message || 'Invalid verification code. Please try again.');
      setCode(['', '', '', '', '', '']);
      setTimeout(() => {
        focusInput(0);
      }, 100);
    } finally {
      setLoading(false);
    }
  };

  const handleResendCode = async () => {
    setResendLoading(true);
    try {
      await resendResetCode(userId);
      message.success('Verification code has been resent to your email');
    } catch (error) {
      message.error('Failed to resend code. Please try again.');
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div style={{
      background: '#EFF3F6',
      flex: 1,
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh"
    }}>
      <Card
        style={{
          width: '100%',
          maxWidth: 400,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <div style={{
            width: 60,
            height: 60,
            borderRadius: '50%',
            backgroundColor: '#e6f7ff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px'
          }}>
            <MailOutlined style={{ fontSize: 24, color: '#1890ff' }} />
          </div>
          <h2 style={{ margin: 0, color: '#1890ff' }}>Verify Your Email</h2>
        </div>

        <p style={{ marginBottom: '30px', color: '#666', textAlign: 'center' }}>
          We've sent a 6-digit verification code to
          <br />
          <strong>{email}</strong>
        </p>

        <div style={{ marginBottom: '30px' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: '8px',
            marginBottom: '10px'
          }}>
            {code.map((digit, index) => (
                <Input
                    key={index}
                    ref={(el) => {
                      if (el) {
                        inputRefs.current[index] = el.input || el;
                      }
                    }}
                    value={digit}
                    onChange={(e) => handleCodeChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    style={{
                      width: 50,
                      height: 50,
                      textAlign: 'center',
                      fontSize: 18,
                      fontWeight: 'bold'
                    }}
                    maxLength={1}
                />
            ))}
          </div>
        </div>

        <Button
          type="primary"
          onClick={handleSubmit}
          loading={loading}
          disabled={loading}
          block
          size="large"
          style={{ marginBottom: '20px' }}
        >
          Verify Code
        </Button>

        <div style={{textAlign: 'center', marginBottom: '20px'}}>
          <span style={{color: '#666'}}>Didn't receive the code? </span>
          <Button
              type="link"
              onClick={handleResendCode}
              style={{padding: 0}}
              disabled={reSendLoading}
              loading={reSendLoading}
          >
            Resend Code
          </Button>
        </div>


        <div style={{textAlign: 'center'}}>
          <Button
              type="link"
              icon={<ArrowLeftOutlined/>}
              onClick={() => navigate('/forgot-password')}
              style={{padding: 0}}
          >
            Back to Forgot Password
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default VerifyCode;